import { Integer} from "../types/base";

export class CommonUtil {

	/**
	 * promise 版本的计时器
	 * @param {number} time
	 * @returns {Promise<any>}
	 */
	static async sleep (time: number = 0): Promise<any> {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve()
			}, time)
		})
	}

	static booleanToNumber (boo: boolean): 0|1 {
		if (boo === true) {
			return 1
		} else {
			return 0
		}
	}

	static isResultEmpty (data: any): boolean {
		if (CommonUtil.isUndefined(data) || CommonUtil.isNull(data) || data === '' || (CommonUtil.isArray(data) && data.length === 0)) {
			return true
		}
		return false
	}

	/**
	 * 是否是integer类型
	 * @param num
	 * @returns {boolean}
	 */
	static isInteger (num: any): boolean {
		if (num === null || CommonUtil.isNumber(num)) {
			return true
		} else {
			return false
		}
	}

	/**
	 * 字段是否为空
	 * @param field
	 * @returns {boolean}
	 */
	static isFieldEmpty (field: any): boolean {
		if (CommonUtil.isUndefined(field) || CommonUtil.isNull(field) || field === '') {
			return true
		}
		return false
	}

	/**
	 * fixed 兼容
	 */
	static toFixed (data: Integer|undefined, num: number = 2): string {
		if (CommonUtil.isNumber(data)) {
			return data!.toFixed(num)
		} else {
			return ''
		}
	}

	/**
	 * 清空表单
	 * @param searchForm
	 */
	static clearForm (searchForm: object, excludes: string[]=[] ) {
		for (let k in searchForm) {
			if (excludes.includes(k)) {
				continue
			}
			let item = searchForm[k]
			if (CommonUtil.isInteger(item)) {
				searchForm[k] = null
			} else if (CommonUtil.isString(item)) {
				searchForm[k] = null
			} else if (CommonUtil.isArray(item)) {
				searchForm[k] = []
			} else if (CommonUtil.isBoolean(item)) {
				searchForm[k] = null
			}
		}
	}

	static print(params: string) {
		window.open(`/tms/report/server?${params}`,"_blank",
			`toolbar=no, location=no, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=1000, height=600, left=${(window.screen.width-1000)/2}, top=100`);

	}

	static checkRowData<T>(rowData:T[],fn:(T)=>boolean):boolean {
		for (let i = 0, l = rowData.length; i < l; i++) {
			let item = rowData[i];
			let res = fn(item)
			if (!res) {
				return  false
			}
		}
		return true
    }
    
    static isBoolean(data): boolean {
        return Object.prototype.toString.apply(data) === "[object Boolean]"
    }

    static isString(data): boolean {
        return Object.prototype.toString.apply(data) === "[object String]"
    }

    static isDate(data): boolean {
        return Object.prototype.toString.apply(data) === "[object Date]"
    }

    static isUndefined(data): boolean {
        return Object.prototype.toString.apply(data) === "[object Undefined]"
    }
    static isFunction(data): boolean {
        return Object.prototype.toString.apply(data) === "[object Function]"
    }

    static isNull(data): boolean {
        return Object.prototype.toString.apply(data) === "[object Null]"
    }

    static isArray(data): boolean {
        return Array.isArray(data)
    }

    static isNumber(data): boolean {
        return Object.prototype.toString.apply(data) === "[object Number]" && !Number.isNaN(data)
    }
    static groupBy<T>(data: T[], field):{[str: string]: T[]} {
        let map = {}
        data.forEach(i=> {
            map[i[field]] = map[i[field]]||[]
            map[i[field]].push(i)
        })
        return map
    }
    static treeForEach<T>(data: T[], fn: (item: T)=> void ,childField='children') {
        let quene = [...data]
        while(quene.length !== 0) {
            let item = quene.shift()
            fn(item!)
            if(item![childField]) {
                Array.prototype.push.apply(quene, item![childField])
            }
        }
    }
}
